import React, { useEffect, useState } from "react";
import { useNavigate, useParams } from "react-router-dom";
import Loader from "../../common/loader";
import { formatDateWithTime, formateDate, formateDateWithMonth, getAppointmentPrice, getAppointmentTypeLabel, handleServerValidations } from "../../../../utils/commonfunction";
import { useTranslation } from "react-i18next";
import { accociateUpdate, AppointmentListIn, AssociateList, Details } from "../../services/appointment.service";
import Breadcrums from "../../common/breadcrumbs";
import { Placeholder } from "rsuite";
import StatusFilter from "../../common/statusFilter";
import { GenderPreference, showFilterListByAppointmentStatus, showFilterListByNotAssignedPerson, SWAL_SETTINGS, THEME_COLORS } from "../../../../utils/Constants";
import AppointmentList from "./list";
import Swal from "sweetalert2";

const AppointmentView = (props) => {
  const navigate = useNavigate();
  const { t } = useTranslation();
  const params = useParams();

  const [data, setData] = useState("");
  const [showdefault, setShowDefault] = useState({});
  const [associateData, setAssociateData] = useState([]);
  const [loading, setLoading] = useState(true);

  const breadcrumbs = [
    { title: t("sidebar_link_dashboard"), url: "/admin/dashboard" },
    { title: t("label_appointment_detail"), url: "/admin/appointments/list/1" },
    { title: t("btn_view"), url: "" },
  ];

  useEffect(() => {
    if (!params?._id) return;

    setLoading(true);
    Details({ _id: params._id })
      .then((response) => {
        const appointmentData = response?.data || {};
        setShowDefault(appointmentData);

        if (appointmentData?.associateData?._id) {
          setData(appointmentData.associateData._id);
        }
        setLoading(false);
      })
      .catch((error) => {
        console.log("Details error:", error);
        setLoading(false);
      });
  }, [params._id]);

  useEffect(() => {
    if (!params?._id) return;

    AssociateList(params._id)
      .then((response) => {
        console.log("AssociateList response:", response);
        setAssociateData(response?.data || []);
      })
      .catch((error) => {
        console.log("AssociateList error:", error);
        setAssociateData([]);
      });
  }, [params._id]);

  const handleSubmit = () => {
    if (!data.trim()) {
      Swal.fire({
        icon: "warning",
        text: "Please select an associate or enter associate ID",
        ...SWAL_SETTINGS,
      });
      return;
    }

    Swal.fire({
      customClass: "swal-wide",
      title: t("msg_are_you_sure"),
      text: t("You want to assign?"),
      icon: "warning",
      showCancelButton: true,
      cancelButtonText: t("btn_cancel"),
      confirmButtonColor: THEME_COLORS.ADMIN_PRIMARY,
      cancelButtonColor: "#000",
      confirmButtonText: t("Yes"),
    }).then((result) => {
      if (result.isConfirmed) {
        const formdata = new FormData();
        formdata.append("_id", data.trim());
        formdata.append("appointment_id", params._id);

        accociateUpdate(formdata)
          .then((response) => {
            if (response.success) {
              Swal.fire({
                icon: "success",
                text: response.message,
                ...SWAL_SETTINGS,
              }).then(() => {
                navigate("/admin/appointments/list/1");
              });
            } else {
              Swal.fire({
                icon: "error",
                text: handleServerValidations(response),
                ...SWAL_SETTINGS,
              });
            }
          })
          .catch((error) => {
            console.log("Update error:", error);
            Swal.fire({
              icon: "error",
              text: "Something went wrong!",
              ...SWAL_SETTINGS,
            });
          });
      }
    });
  };

  if (loading) {
    return (
      <div className="row row-sm">
        <div className="col-lg-12 col-md-12 animation_fade">
          <div className="card custom-card">
            <div className="card-body">
              <Loader />
            </div>
          </div>
        </div>
      </div>
    );
  }

  return (
    <>
      <Breadcrums data={breadcrumbs} />
      <div className="row row-sm">
        <div className="col-lg-12 col-md-12 animation_fade">
          <div className="card custom-card">
            <div className="card-body">
              <div>
                <h6 className="main-content-label mb-3">{t("label_appointment_detail")}</h6>
              </div>

              {showdefault && Object.keys(showdefault).length > 0 ? (
                <div className="row">
                  <div className="col-lg-12 form-group">
                    <table className="table table-bordered table-hover" style={{ tableLayout: "fixed", width: "100%" }}>
                      <colgroup>
                        <col style={{ width: "25%" }} />
                        <col style={{ width: "75%" }} />
                      </colgroup>
                      <tbody>
                        <tr>
                          <th>{t("label_booking_id")}</th>
                          <td className="text-capitalize">{showdefault?.requestID || "N/A"}</td>
                        </tr>

                        {showdefault && (showdefault.status === "not_assigned" || showdefault.status === "pending") && new Date(showdefault.appointmentDate) > new Date() && (
                          <tr>
                            <th>Assign Associate</th>
                            <td>
                              <div className="mt-3">
                                <button
                                  className="btn btn-primary"
                                  onClick={() => {
                                    navigate(`/admin/appointments/assign-associate/list/${params?._id}/1`);
                                  }}
                                >
                                  Get Associate List
                                </button>
                              </div>
                            </td>
                          </tr>
                        )}

                        {showdefault?.logsArray?.length > 0 && (
                          <tr>
                            <th>Show Logs</th>
                            <td>
                              <div className="mt-3">
                                <button className="btn btn-primary" onClick={() => navigate(`/admin/appointments/logs/${params?._id}`)}>
                                  Get Logs
                                </button>
                              </div>
                            </td>
                          </tr>
                        )}

                        <tr>
                          <th>{t("label_user_email")}</th>
                          <td>{showdefault?.userData?.email || "N/A"}</td>
                        </tr>

                        <tr>
                          <th>{t("label_user_name")}</th>
                          <td>{showdefault?.userData?.name || "N/A"}</td>
                        </tr>

                        <tr>
                          <th>{t("label_user_rating")}</th>
                          <td>{Number(showdefault?.userData?.avgRating).toFixed(2) || "N/A"}</td>
                        </tr>

                        <tr>
                          <th>{t("label_associate_email")}</th>
                          <td>{showdefault?.associateData?.email || "N/A"}</td>
                        </tr>

                        <tr>
                          <th>{t("label_associate_name")}</th>
                          <td>{showdefault?.associateData?.name || "N/A"}</td>
                        </tr>

                        <tr>
                          <th>{t("label_associate_rating")}</th>
                          <td>{Number(showdefault?.associateData?.avgRating).toFixed(2) || "N/A"}</td>
                        </tr>

                        {showdefault?.gender !== null &&
                          showdefault?.gender !== undefined && (
                            <tr>
                              <th>{t("selected_appointment_gender")}</th>
                              <td>
                                {
                                  GenderPreference.find(
                                    item => item.value === showdefault?.gender
                                  )?.label || "N/A"
                                }
                              </td>
                            </tr>
                          )}

                        <tr>
                          <th>{t("label_booking_date")}</th>
                          <td>{showdefault?.appointmentDate ? formatDateWithTime(showdefault.appointmentDate) : "N/A"}</td>
                        </tr>

                        <tr>
                          <th>{t("label_status")}</th>
                          <td className="text-capitalize">{showdefault?.status ? t(showdefault.status) : "N/A"}</td>
                        </tr>

                        <tr>
                          <th>Appointment Type</th>
                          <td className="text-capitalize">{getAppointmentTypeLabel(showdefault?.appointmentType, showdefault?.appointmentDate)}</td>
                        </tr>

                        <tr>
                          <th>Discount</th>
                          <td>{showdefault?.discount_amount ? `$${showdefault.discount_amount }` : "N/A"}</td>
                        </tr>

                        <tr>
                          <th>{t("label_price")}</th>
                          <td>
                            {getAppointmentPrice(showdefault?.appointmentType, showdefault?.subCategoryData) !== "N/A"
                              ? `$${getAppointmentPrice(showdefault?.appointmentType, showdefault?.subCategoryData)}`
                              : "N/A"}
                          </td>
                        </tr>

                        <tr>
                          <th>{t("label_prescription")}</th>
                          <td>{showdefault?.prescriptionNote || "N/A"}</td>
                        </tr>

                        {/* <tr>
                          <th>{t("label_prescription_image")}</th>
                          <td>
                            {showdefault?.prescriptionImage ? (
                              <img src={showdefault.prescriptionImage} alt="Prescription" style={{ height: "100px", width: "auto" }} onError={(e) => (e.target.style.display = "none")} />
                            ) : (
                              "N/A"
                            )}
                          </td>
                        </tr> */}

                        <tr>
                          <th>{t("label_address")}</th>
                          <td>{showdefault?.appointmentAddress?.address || "N/A"}</td>
                        </tr>

                        <tr>
                          <th>{t("label_distance")}</th>
                          <td>{showdefault?.distance ? `${showdefault.distance} Miles` : "N/A"}</td>
                        </tr>

                        <tr>
                          <th>Service Category</th>
                          <td>{showdefault?.categoryData?.title || "N/A"}</td>
                        </tr>

                        <tr>
                          <th>Sub Service Category</th>
                          <td>{(showdefault?.subCategoryData?.title === 'Massage (The Recovery)' ? 'Massage (The Recovery 60)' : showdefault?.subCategoryData?.title) || "N/A"}</td>
                        </tr>

                        {
                          showdefault?.subCategoryData?.massage_slug &&
                          <tr>
                            <th>{t("label_sub_type")}</th>
                            <td>
                              {showdefault?.subCategoryData?.massage_name
                                ? showdefault.subCategoryData.massage_name
                                  .split(" ")
                                  .map(
                                    word =>
                                      word.charAt(0).toUpperCase() +
                                      word.slice(1).toLowerCase()
                                  )
                                  .join(" ")
                                : "N/A"}
                            </td>
                          </tr>
                        }

                        {showdefault?.can_perform_pregnancy_massage !== null &&
                          showdefault?.can_perform_pregnancy_massage !== undefined && (
                            <tr>
                              <th>{t("can_perform_pregnancy_massage")}</th>
                              <td>
                                {showdefault?.can_perform_pregnancy_massage ? 'Yes' : 'No'}
                              </td>
                            </tr>
                          )}
                        {showdefault?.subCategoryData?.time_interval > 0 && (
                          <tr>
                            <th>Duration</th>
                            <td>{showdefault.subCategoryData.time_interval} Minutes</td>
                          </tr>
                        )}

                        <tr>
                          <th>{t("label_dispute_reason")}</th>
                          <td>{showdefault?.disputeReason || "N/A"}</td>
                        </tr>

                        <tr>
                          <th>{t("label_dispute_reason_detail")}</th>
                          <td>{showdefault?.disputeReasonDetails || "N/A"}</td>
                        </tr>

                        <tr>
                          <th>{t("label_cancellation_reason")}</th>
                          <td>{showdefault?.cancelationReason || "N/A"}</td>
                        </tr>

                        <tr>
                          <th>{t("label_incompletion_reason")}</th>
                          <td>{showdefault?.incompletionReason || "N/A"}</td>
                        </tr>
                      </tbody>
                    </table>
                  </div>
                </div>
              ) : (
                <Placeholder.Paragraph className="w-100 admin-placeholder" rowHeight={30} rowSpacing={5} active={true} rows={7} />
              )}
            </div>

            <div className="mt-2 back-button mx-4">
              <button className="btn ripple btn-dark" type="button" onClick={() => navigate("/admin/appointments/list/1")}>
                <i className="ace-icon-solid ion-arrow-return-left bigger-110 mx-1"></i>
                {t("btn_back")}
              </button>
            </div>
          </div>
        </div>
      </div>
    </>
  );
};

export default AppointmentView;
